import  gql  from 'graphql-tag'

export const TOKEN_AUTH = gql`mutation tokenAuth($input: ObtainJSONWebTokenInput!){
    tokenAuth(input: $input){
        token
        refreshToken
        idleTime
        user{
            name
            surname
            username
            group{
                name
                permissions{
                edges{
                    node{
                    name
                    codename
                    }
                }
                }
            }
        }
    }
}`;